import React from 'react';
import { StyledP } from './SearchHeaderText.styles';

const SearchHeaderText = (props) => {
  const { text } = props;

  return <StyledP>{text}</StyledP>;
};

export default SearchHeaderText;
